import { useFeedStore } from '@modules/feed/store/feedStore';
import { SearchActionType } from '@modules/feed/store/searchActionType';
import { FeedbackSummaryActionType } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryActionType';
import { useFeedbackSummaryStore } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryStore';
import { QueryBuilder } from '@modules/queryBuilder/components/QueryBuilder';
import { trackQBEvent } from '@modules/queryBuilder/events';
import { QueryOnChangeProps } from '@modules/queryBuilder/types';
import { Box } from '@mui/material';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { mapToEQL } from 'v2/core/repository/eql/mappers';
import { ExpressionType } from 'v2/core/repository/eql/types';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { shallow } from 'zustand/shallow';

export function SearchQueryBuilderV2() {
  const { dispatch, whereClause } = useFeedStore(
    ({ dispatch, query: { whereClause } }) => ({
      dispatch,
      whereClause,
    }),
    shallow,
  );

  const feedbackSummaryDispatch = useFeedbackSummaryStore(
    ({ dispatch }) => dispatch,
  );

  const { data: sourceDetailsMap } = useGetSourceDetailsMap();

  const onExecute = ({ whereClause }: QueryOnChangeProps) => {
    dispatch({
      type: SearchActionType.SET_QUERY,
      payload: {
        whereClause,
      },
    });

    feedbackSummaryDispatch({
      type: FeedbackSummaryActionType.RESET,
    });

    trackQBEvent({
      eventName: 'Query Builder Action Event',
      action: {
        type: 'EXECUTE_QUERY',
        eql: mapToEQL({
          whereClause: whereClause,
          expressionType: ExpressionType.Records,
          sourceDetailsMap: sourceDetailsMap ?? new Map(),
        }),
        display: '',
        searchMetadata: '',
        qbContext: 'Search',
      },
    });
  };

  return (
    <Box>
      <QueryBuilder
        whereClause={whereClause ?? EmptyWhereClause}
        onExecute={onExecute}
      />
    </Box>
  );
}
